@if (internalErrors.length > 0) {
  @if (visible && variant === 'alert') {
    <ngb-alert class="p-0" [dismissible]="false" [ngClass]="alertClass" type="danger">
      <ng-container
        [ngTemplateOutlet]="errorTemplate"
        [ngTemplateOutletContext]="{ errors: internalErrors }"
      ></ng-container>
    </ngb-alert>
  }
  @if (variant === 'plain') {
    <div>
      <ng-container [ngTemplateOutlet]="title"></ng-container>
      <portal-icon-button (onClick)="showDetails()" iconClass="far fa-info-circle"></portal-icon-button>
    </div>
  }
  <ng-template #errorTemplate let-errors="errors">
    <portal-error-header
      [dismissible]="dismissible"
      [errors]="errors"
      [summary]="summary"
      [title]="title"
      (hide)="hide()"
      (toggle)="collapse.toggle()"
    ></portal-error-header>
    <div #collapse="ngbCollapse" [ngbCollapse]="collapsed">
      <portal-error-body [errors]="internalErrors"></portal-error-body>
    </div>
  </ng-template>
}
